(function(){
    'use strict';

    angular.module('elogbooks.admin.job-groups', []);
})();
